import type { Dogtag } from "@/types/gloss";

const defaultDogtag: Dogtag = {
  background_color_id: 4293577648,
  background_id: 4293905328,
  border_color_id: 4293348272,
  symbol_id: 4293872560,
  texture_id: 4293282736,
}

export { defaultDogtag };
